import schedule from './schedule';

export default schedule;
